<template lang="pug">
  .full-width
    v-overlay(
      v-if="isLoading",
      :value="isLoading"
    )
      v-progress-circular(:value="20" indeterminate)
    v-row(
      no-gutter,
      v-else,
    )
      v-col(
        v-if="isSuperadmin",
        cols="12",
      )
        ExportAnalysis(:min-date="startDate")
          template(v-slot:default="{ open }")
            v-btn.mt-4(
              color="primary",
              :ripple="false",
              @click="open",
            )
              v-icon(left) fas fa-file-download
              | {{ $t('form.exportAnalysis.header') }}
</template>

<script>
import { mapGetters } from "vuex";
import { and, curryN, equals, find, path, prop, propOr, sortBy } from "ramda";
import { progressWrapper, roleManager } from "@/config/mixins.js";
import { buildDateRange, formatDate, getEarlierDate } from "@/utils/time";

import ExportAnalysis from "@/components/forms/ExportAnalysis.vue";
const findShopData = curryN(
  3,
  (shop_id, date_index, { shop_id: data_shop_id, formattedDate }) =>
    and(equals(data_shop_id, shop_id), equals(formattedDate, date_index))
);

export default {
  components: {
    ExportAnalysis,
  },

  mixins: [progressWrapper, roleManager],

  data: () => ({
    stats: [],
    dateIndex: [],
    startDate: new Date(),
  }),

  computed: {
    ...mapGetters({
      shops: "shop/items",
    }),
  },

  created() {
    this.wrapProgress(() =>
      Promise.all([this.$store.dispatch("shop/fetch", { hardFetch: true })])
    );
  },
};
</script>
